import { faInfoCircle, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

  function FormInput({ 
    label, nameInput,  nameClass, nameClassContainer, type, maxLength, placeholder, nameClassLabel, nameClassLabelContainer,
    register, errors, isNumber,  disabled, flashError, flashErrorIndex1, validation, validMessage, requireMessage, errorClass,  
    clearErrors, clearsName, isError, pattern, icon, reset, setValue, min, max
  }) {
    
    const resetValues = () => {
      setValue(nameInput, '')
    }

    return(
      <div className={nameClassContainer}>
        {label && 
          <label htmlFor={nameInput} className={`${nameClassLabelContainer}`}>
            <p className={nameClassLabel}>{label}</p>
          </label>
        }
        {icon && <i className={icon + ' input-icon'}></i>}
        {reset && <i className="bi bi-x-lg close-input-btn" onClick={resetValues}></i>}
        <div className="grow">
          {((type === 'text' || type === 'number')) && 
            <input  
              type={type} className={`${nameClass} ${errors?.[nameInput] ? 'border-2 border-red-600 outline-none' : ''}`} 
              autoComplete="off" autoCorrect="off" pattern={pattern} min={min ?? null} max={max ?? null}
              maxLength={maxLength ?? null} placeholder={placeholder ?? null} id={nameInput} disabled={disabled ?? false}
              {...register(nameInput, {
                valueAsNumber: isNumber,
                onChange: (e) => {
                  clearsName && clearErrors(clearsName)
                },
                pattern: !validation ? null : {
                  value: validation, message: validMessage
                },
                required: {
                  value: !requireMessage ? false : true,
                  message: requireMessage
                }
              })}
            />
          }
          {(errors?.[nameInput]) && 
            <p className={`font-semibold text-red-600 mt-2`}>
              <FontAwesomeIcon icon={faInfoCircle} className="mr-2"/>
              {errors[nameInput]?.message}
            </p>
          }
        </div>
      </div>
    )
  }

  export default FormInput